export default __webpack_public_path__ + "static/media/logo-BPO.79173423.png";